export enum LevelStatus {
    EMPTY = 'empty',
    LOADING = 'loading',
    LOADED = 'loaded',
    INTRO = 'intro',
    ACTIVE = 'active',
    COMPLETE = 'complete',
    FAILED = 'failed',
    EXITING = 'exiting',
    RESTARTING = 'restarted',
}
